<template>
    <button
        id="main-navigation-button"
        :aria-current="groupName.includes(currentGroupName) ? 'step' : false"
        :class="[
            headerFontClass,
            'cz2__main-navigation-button',
            {
                'cz2__main-navigation-button-enlarge-text': groupName !== 'Review' && groupName !== 'Name Your Pop!',
            },
        ]"
        :data-reclaim-focus="shouldReclaimFocus"
    >
        <div class="cz2__main-navigation-button-content-wrapper">
            <div
                v-if="isTwoPack && !isReviewStep"
                class="cz2__main-navigation-button-subheading"
            >
                {{ twoPackHeading }}
            </div>

            <div class="cz2__main-navigation-button-title-wrapper">
                <h1
                    v-html="groupName"
                    id="step-header-title"
                    class="cz2__main-navigation-button-content"
                />

                <img
                    v-if="isSpellingBee && light"
                    :class="{ 'dropdown__indicator-open': isOpen }"
                    src="../assets/icons/double-chevron-dark-blue.svg"
                    alt=""
                    class="cz2__main-navigation-button-content cz2__main-navigation-button-content__sb-chevron"
                />

                <img
                    v-else-if="isSpellingBee && !light"
                    :class="{ 'dropdown__indicator-open': isOpen }"
                    src="../assets/icons/double-chevron-white.svg"
                    alt=""
                    class="cz2__main-navigation-button-content cz2__main-navigation-button-content__sb-chevron"
                />

                <img
                    v-else
                    :class="{ 'dropdown__indicator-open': isOpen }"
                    src="../assets/icons/chevron-white.svg"
                    :width="isKiosk ? '32.31' : '20'"
                    :height="isKiosk ? '21.22' : '13'"
                    alt=""
                    class="cz2__main-navigation-button-content"
                />

                <img
                    v-if="hasAlert"
                    src="../assets/icons/alert.svg"
                    width="57"
                    height="49"
                    alt="Warning"
                    class="cz2__main-navigation-button-alert"
                />
            </div>
        </div>
    </button>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__main-navigation-button {
            position: relative;

            height: var(--mainNavHeight);

            font-size: 32px;
            text-transform: uppercase;
            font-style: italic;
            color: color(primaryWhite);

            &:focus {
                outline: none;

                &:before {
                    position: absolute;
                    top: -3px;
                    left: -11px;

                    width: calc(110% + 6px);
                    height: calc(100% + 6px);
                    content: '';
                    clip-path: polygon(0 0, 98% 8%, 94% 90%, 2% 100%);
                    background-color: color(primaryWhite);
                }
            }

            .cz2__main-navigation-button-content-wrapper {
                position: relative;

                padding: 0 8px;

                display: flex;
                flex-direction: column;

                &:before {
                    position: absolute;
                    left: -8px;

                    width: 110%;
                    height: 100%;
                    content: '';
                    clip-path: polygon(0 0, 98% 8%, 94% 90%, 2% 100%);
                    background-color: color(v2Red);
                }
            }

            .cz2__main-navigation-button-subheading {
                margin: 6px 0 -8px 8px;

                font-size: 14px;
                letter-spacing: normal;
            }

            .cz2__main-navigation-button-title-wrapper {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 12px;
            }

            .cz2__main-navigation-button-subheading, .cz2__main-navigation-button-content {
                position: relative;

                display: flex;
            }

            img {
                transition: transform 0.2s linear;
            }

            .dropdown__indicator-open {
                transform: rotate(-180deg);
            }

            .cz2__main-navigation-button-alert {
                position: absolute;
                top: -2px;
                right: -44px;
            }

            @include respond-above(lg) {
                font-size: 50px;

                .cz2__main-navigation-button-subheading {
                    margin-left: 10px;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__main-navigation-button {
            margin-left: 40px;
            font-size: 81px;

            img {
                margin-left: 16px;
            }
        }

        .cz2__main-navigation-button-enlarge-text {
            font-size: 96px;
        }

        .cz2__main-navigation-button-subheading {
            font-size: 35px;
            margin-left: 18px;
            margin-bottom: -18px;
        }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   ▗▄▄▖▗▄▄▖ ▗▄▄▄▖▗▖   ▗▖   ▗▄▄▄▖▗▖  ▗▖ ▗▄▄▖    ▗▄▄▖ ▗▄▄▄▖▗▄▄▄▖
    //  ▐▌   ▐▌ ▐▌▐▌   ▐▌   ▐▌     █  ▐▛▚▖▐▌▐▌       ▐▌ ▐▌▐▌   ▐▌
    //   ▝▀▚▖▐▛▀▘ ▐▛▀▀▘▐▌   ▐▌     █  ▐▌ ▝▜▌▐▌▝▜▌    ▐▛▀▚▖▐▛▀▀▘▐▛▀▀▘
    //  ▗▄▄▞▘▐▌   ▐▙▄▄▖▐▙▄▄▖▐▙▄▄▖▗▄█▄▖▐▌  ▐▌▝▚▄▞▘    ▐▙▄▞▘▐▙▄▄▖▐▙▄▄
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    #cz2.cz2__is-sb {
        .cz2__main-navigation-button {
            width: 265px;

            @include respond-above(lg) {
                max-width: 100%;
                width: 709px;
            }

            &:focus {
                outline: none;

                &:before {
                    position: absolute;
                    left: -6px;
                    top: -5px;

                    width: calc(100% + 12px);
                    height: calc(100% + 10px);
                    content: '';
                    clip-path: none !important;
                    background-color: color(primaryWhite);
                }
            }

            .cz2__main-navigation-button-subheading {
                margin-left: 0;

                text-transform: uppercase;
                font-family: 'Proxima Nova', sans-serif;
                font-size: 14px;

                justify-content: center;

                @include respond-above(sm) {
                    font-size: 23px;
                }
            }

            .cz2__main-navigation-button-content-wrapper {
                position: relative;

                padding: 0 8px;

                display: flex;
                flex-direction: column;

                font-style: normal;
                text-transform: none;

                border: 3px solid color(primaryWhite);
                box-shadow: 0px 0px 0px 3px color(sbDarkGold);

                &:focus {
                    left: 0 !important;
                    outline: none;

                    &:before {
                        position: absolute;
                        top: 0;
                        left: 0;

                        width: 100%;
                        height: 100%;
                        content: '';
                        clip-path: none !important;
                        background-color: color(primaryWhite);
                    }
                }

                &:before {
                    position: absolute;
                    left: 0;

                    width: 100%;
                    height: 100%;
                    content: '';
                    clip-path: none !important;
                    background-color: color(sbDarkBlue) !important;
                }

                h1.cz2__main-navigation-button-content {
                    font-size: 24px;

                    @include respond-above(md) {
                        font-size: 55px;
                        line-height: 1;
                    }
                }

                .cz2__main-navigation-button-content {
                    margin-top: 4px;
                    margin-bottom: 4px;

                    @include respond-above(md) {
                        margin-top: 8px;
                        margin-bottom: 8px;
                    }

                    &.cz2__main-navigation-button-content__sb-chevron {
                        margin: 0;

                        position: absolute;
                        height: 16px;
                        right: 16px;

                        @include respond-above(md) {
                            position: absolute;

                            right: 32px;
                            height: 34px;
                        }
                    }
                }
            }
        }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // SPELLING BEE: KIOSK
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    #cz2.cz2.cz2__is-kiosk.cz2__is-sb {
        .cz2__main-navigation-button-enlarge-text {
            font-size: 75px !important;
        }

        .cz2__main-navigation-button {
            margin-left: 0;

            max-width: 100%;
            width: 822px;
        }

        .cz2__main-navigation-button-content {
            line-height: 40px;

            margin-top: 12px;
            margin-bottom: 12px;
        }

        .cz2__main-navigation-button-content-wrapper {
            box-shadow: 0px 0px 0px 5px color(sbDarkGold);
            border: 5px solid #ffffff;

            h1.cz2__main-navigation-button-content {
                font-size: 75px;
            }
        }

        .cz2__main-navigation-button-content.cz2__main-navigation-button-content__sb-chevron {
            width: 40px;
            height: 40px;
        }
    }
</style>

<script>
    import * as constants from '../constants';

    export default {
        props: {
            group: Object,
            isOpen: Boolean,
            shouldReclaimFocus: Boolean,
            light: Boolean,
        },

        computed: {
            headerFontClass() {
                return this.$store.getters.headerFontClass;
            },

            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },

            isReviewStep() {
                return this.group.code === 'Review';
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            isFirstPop() {
                return this.$store.state.customizer.viewController === this.$store.getters.popControllers[0];
            },

            twoPackHeading() {
                return this.isFirstPop ? this.$t('FIRST_POP') : this.$t('SECOND_POP');
            },

            currentGroupName() {
                return this.mapGroupName(this.group.name);
            },

            groupName() {
                if (this.group == null) {
                    return null;
                }

                return this.mapGroupName(this.group.name);
            },

            isBaby() {
                const activePopController = this.$store.state.customizer.viewController;
                const body = activePopController?.selectedAtPlacement(constants.PLACEMENT_BODY);

                return body?.custom?.['fun-baby'] === 'true';
            },

            alertGroups() {
                return this.$store.state.customizer.alertGroups;
            },

            hasAlert() {
                return this.alertGroups.includes(this.group.code);
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },
        },

        methods: {
            mapGroupName(name) {
                if (this.isBaby && (name === 'Lashes' || name === 'Head')) {
                    return this.$t('STEP_HEAD_BABY');
                }

                if (this.isTwoPack && name === 'Name Your Pop!') {
                    return this.$t('STEP_NAME_POP');
                }

                return name;
            },
        },
    };
</script>
